import toastr from 'react-hot-toast';
import React from 'react';
import { useQuery } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import { CACHE_AND_STALE_TIME } from 'constants/index';
import type { SinglePluginsResponse } from 'types/Plugins';
import { DropdownOption } from 'types/common/DropdownOption';
import {
  generateIncludeQuery,
  generateURL,
} from 'utilities/hooks/urlGeneration';
import { SPARK_RESOURCE_TYPES } from 'constants/common';

const getPluginFunctions = (pluginsID: string | null | undefined) => {
  const queryArray = [generateIncludeQuery(['pluginFunctions'])];

  const url = generateURL(SPARK_RESOURCE_TYPES.PLUGINS, queryArray, pluginsID);

  return fetchWrapper<SinglePluginsResponse>({
    url: url,
    method: 'GET',
  });
};

export function usePluginsByID(pluginsID: string | null | undefined) {
  const queryResult = useQuery(
    ['plugin', pluginsID],
    () => getPluginFunctions(pluginsID),
    {
      onError: (error) => {
        if (error instanceof Error) {
          toastr.error(`failed to Fetch Plugin Functions: ${error.message}`);
        }
      },
      enabled: Boolean(pluginsID),
      ...CACHE_AND_STALE_TIME,
    }
  );
  const { data: pluginFunctionsResponse } = queryResult;
  const { data: plugin, included: pluginFunctions } =
    pluginFunctionsResponse || {};

  const pluginFunctionDropdownOptions = React.useMemo(() => {
    return pluginFunctions?.reduce<DropdownOption[]>((acc, curr) => {
      const option = { label: curr.attributes.name, value: curr.id };

      return [...acc, option];
    }, []);
  }, [pluginFunctions]);

  return {
    pluginFunctionDropdownOptions,
    plugin,
    pluginFunctions,
    ...queryResult,
  };
}
